import { TOAST_TYPES } from '../organisms/appLayout/molecules/globalCommunicationWrapper/globalCommunicationWrapper.types'
import { addGlobalMessage } from '../organisms/appLayout/molecules/globalCommunicationWrapper/GlobalCommunicationWrapper'
import { isHttpClientError } from '../utils/HttpClient'
import QuinceApiError, { isQuinceApiError } from './quince-api-error'
import isBrowser from '../utils/isBrowser'
import { captureException } from '../utils/sentryUtil'
import { FeatureType, ModuleType } from '../constants/template-info'

export interface QuinceServicesErrorResponse {
  errorCode: string
  message: string
  dateTime: string
}

const STANDARD_ERROR_MESSAGE = 'Something went wrong please try again later'

class QuinceError extends Error {
  displayMessage: string
  parentError?: Error

  constructor(message: string, displayMessage: string, parentError?: Error) {
    super(message)
    this.displayMessage = displayMessage
    this.parentError = parentError
    return {
      ...this,
    }
  }

  static captureDataException = (
    error: Error | QuinceApiError,
    errorInfo: Record<string, any> | undefined = {},
    errorTags: Record<string, any> | undefined = {},
    module: ModuleType,
    feature: FeatureType,
  ) => {
    if (isBrowser()) {
      captureException(error, {
        module: module,
        feature,
        additionalTags: errorTags,
        extraInfo: errorInfo,
      })
    } else {
      throw error
    }
  }

  static fromError(error: Error | QuinceApiError, fallBackMessage?: string) {
    let httpError = error
    if (isQuinceApiError(error)) {
      httpError = error.apiErrorObject
    }

    const defaultError = fallBackMessage || STANDARD_ERROR_MESSAGE
    if (!isHttpClientError(httpError)) {
      return new QuinceError(defaultError, defaultError, error)
    }
    const errorMessage = httpError.response?.data?.message || defaultError

    return new QuinceError(errorMessage, errorMessage, error)
  }

  static toastFromError(
    error: Error,
    options: {
      fallBackMessage?: string
      module: ModuleType
      feature: FeatureType
    },
  ) {
    const { fallBackMessage, module, feature } = options || {}
    const quinceError = QuinceError.fromError(error, fallBackMessage)

    QuinceError.toastFromQuinceError(quinceError)
    captureException(error, {
      module,
      feature,
    })
  }

  static toastFromQuinceError(error: QuinceError) {
    addGlobalMessage({
      title: 'Error',
      description: error.displayMessage,
      type: TOAST_TYPES.error,
    })
  }
}

export default QuinceError
